import React from "react";
import { BsWatch } from "react-icons/bs";
import CategoryCard from "./CategoryCard";
import { AiOutlineDesktop, AiOutlineMobile } from "react-icons/ai";
import { MdLaptop } from "react-icons/md";

//"Laptop", "Mobile", "SmartWatch", "Monitor"

const data = [
  {
    url: "/products/Mobile",
    value: "Mobile",
    title: "Mobile",
    icon: <AiOutlineMobile className="text-orange-500 text-5xl" />,
    description:
      "Explore a world of possibilities with our mobile phones. Personalized solutions for your needs.",
  },
  {
    url: "/products/SmartWatch",
    value: "SmartWatch",
    title: "Smart Watch",
    icon: <BsWatch className="text-orange-500 text-5xl" />,
    description:
      "Stay connected and track your fitness with our smartwatches. Achieve financial freedom.",
  },
  {
    url: "/products/Monitor",
    value: "Monitor",
    title: "Monitor",
    icon: <AiOutlineDesktop className="text-orange-500 text-5xl" />,
    description:
      "Enhance your computing with high-quality monitors. Empower your choices with financial knowledge.",
  },
  {
    url: "/products/Laptop",
    value: "Laptop",
    title: "Laptop",
    icon: <MdLaptop className="text-orange-500 text-5xl" />,
    description:
      "Elevate productivity with top-notch laptops. Trust our financial expertise and buy an authentic one.",
  },
];

const Categories = () => {
  return (
    <div className="bg-white">
      <div className=" grid grid-cols-1 lg:grid-cols-4 gap-5 pt-12 lg:pt-0 lg:-translate-y-10  px-[10px] md:px-[20px] lg:px-[7%] ">
        {data.map((dat) => (
          <CategoryCard
            title={dat.title}
            icon={dat.icon}
            description={dat.description}
            url={dat.url}
            value={dat.value}
          />
        ))}
      </div>
    </div>
  );
};

export default Categories;
